import { el } from "../lib/dom.js";
import { icon } from "../lib/icon.js";

/**
 * Round E batch 1's two list-screen rules (UX spec §E.4, shared.js `busy`), shared by 15, 17 and 19:
 * loading = the region's skeletons hidden from assistive tech and ONE status line that says what loads;
 * couldn't load = what could not be read, what that does not touch, and Try again.
 */
export function setBusy(body: HTMLElement, note: HTMLElement, region: HTMLElement, on: boolean, text: string): void {
  body.setAttribute("aria-busy", on ? "true" : "false");
  note.textContent = on ? text : "";
  if (on) region.setAttribute("aria-hidden", "true");
  else region.removeAttribute("aria-hidden");
}

export function loadFailed(title: string, sub: string, onRetry: () => void, cls = "banner"): HTMLElement {
  const retry = el("button", { class: "raw retry", type: "button" }, ["Try again"]);
  retry.addEventListener("click", onRetry);
  return el("div", { class: cls }, [icon("i-alert"), el("span", { class: "bt" }, [el("b", {}, [title]), el("span", {}, [sub])]), retry]);
}
